import { Add } from '@mui/icons-material';
import { Box, Fab, lighten, SxProps, Theme, Tooltip } from '@mui/material';

import { TourTravelConnexionTypeWithEvent } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function TourTravelAddButton({
  connexionType,
  tourTravelListIsEmpty,
  onClick,
}: {
  connexionType: TourTravelConnexionTypeWithEvent;
  tourTravelListIsEmpty: boolean;
  onClick: () => void;
}) {
  const tooltipText = getButtonText(connexionType);
  const addButtonStyle = getStylePosition(connexionType, tourTravelListIsEmpty);

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          transform: 'translateX(-50%)',
          ...addButtonStyle,
        }}
      >
        <Tooltip title={tooltipText} placement="bottom">
          <Box>
            <FabAddButton onClick={onClick} />
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
}

function getStylePosition(
  connexionType: TourTravelConnexionTypeWithEvent,
  tourTravelListIsEmpty: boolean,
) {
  if (connexionType === 'incoming' && tourTravelListIsEmpty) {
    return { ml: -3, mt: -5 };
  }
  if (connexionType === 'incoming' && tourTravelListIsEmpty === false) {
    return { ml: -21, mt: 1 };
  }
  if (connexionType === 'outgoing' && tourTravelListIsEmpty) {
    return { ml: 3, mt: -5 };
  }
  if (connexionType === 'outgoing' && tourTravelListIsEmpty === false) {
    return { ml: 21, mt: 1 };
  }
  if (connexionType === 'direct' && tourTravelListIsEmpty) {
    return { mt: 0.5 };
  }
  if (connexionType === 'direct' && tourTravelListIsEmpty === false) {
    return { opacity: 0 };
  }
}

function getButtonText(connexionType: TourTravelConnexionTypeWithEvent) {
  switch (connexionType) {
    case 'incoming':
      return translate('ProjectsTour.travel-incoming-button');
    case 'outgoing':
      return translate('ProjectsTour.travel-outgoing-button');
    case 'direct':
      return translate('ProjectsTour.travel-direct-button');
  }
}

function FabAddButton({
  onClick,
  sx,
}: {
  onClick: () => void;
  sx?: SxProps<Theme>;
}) {
  const textColor = ColorsRaw.basic.White;
  const bgColor = ColorsRaw.anthracite.Anthracite_4;
  const hoverBgColor = lighten(bgColor, 0.1);
  return (
    <Fab
      onClick={onClick}
      size="small"
      sx={{
        opacity: 0.3,
        transition: 'opacity 0.2s ease',
        bgcolor: bgColor,
        color: textColor,
        '&:hover': {
          bgcolor: hoverBgColor,
          opacity: 1,
        },
        ...sx,
      }}
    >
      <Add />
    </Fab>
  );
}
